<app-page-header
  title="Home"
  active_item="Visão Geral"
  titleLink="/overview"
></app-page-header>

<app-metabase-public-embed
  [url]="'https://reports.harpiatechnology.io/public/dashboard/617a8d0b-fe89-4233-8cf7-21ddcd71c0c3'"
>
</app-metabase-public-embed>
